export const round = (num: number, decimals: number = 2) => Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);